import styles from "./BookingInterestErrorDialog.module.scss";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export interface BookingInterestErrorDialogProps {
    open: boolean;
    setOpen: Function;
    handleCancelButtonClick?: Function;
    handleAcceptButtonClick: Function;
    dialogTitle: string;
    dialogBody: string;
    dialogAcceptButtonText: string;
    dialogCancelButtonText: string;
}

const BookingInterestErrorDialog: React.FC<BookingInterestErrorDialogProps> = (props: BookingInterestErrorDialogProps) => {
    const { open, setOpen, handleCancelButtonClick, handleAcceptButtonClick,
        dialogTitle, dialogBody, dialogAcceptButtonText, dialogCancelButtonText } = props;

    const handleClose = () => {
        setOpen(false)
        if (handleCancelButtonClick) {
            handleCancelButtonClick();
        }
        
    };

    return (
        <Dialog
            maxWidth={"md"}
            open={open}
            onClose={handleClose}
            className={styles.bookingInterestErrorDialog}
            data-cy="booking-interest-error-dialog"
        >
            <DialogTitle
                id="alert-dialog-title"
                className={styles.title}
                data-cy="booking-interest-error-dialog-title">
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    style={{ whiteSpace: 'pre-line' }}>
                    {dialogBody}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {dialogCancelButtonText &&
                    <Button
                        onClick={handleClose}
                        className={styles.cancelButton}
                        variant="outlined">
                        <AutoAwesomeIcon />
                        {dialogCancelButtonText}
                        <AutoAwesomeIcon />
                    </Button>
                }
                <Button onClick={() => { handleAcceptButtonClick() }} variant="contained" data-cy="booking-interest-error-dialog-accept-button">
                    {dialogAcceptButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default BookingInterestErrorDialog;
